import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const Check = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.36661 11.7166C6.27772 11.7166 6.19438 11.7027 6.11661 11.6749C6.03883 11.6472 5.96661 11.5999 5.89994 11.5333L3.03327 8.6666C2.91105 8.54438 2.85272 8.38605 2.85827 8.1916C2.86383 7.99716 2.92772 7.83882 3.04994 7.7166C3.17216 7.59438 3.32772 7.53327 3.51661 7.53327C3.70549 7.53327 3.86105 7.59438 3.98327 7.7166L6.36661 10.0999L12.0166 4.44993C12.1388 4.32771 12.2972 4.2666 12.4916 4.2666C12.686 4.2666 12.8444 4.32771 12.9666 4.44993C13.0888 4.57216 13.1499 4.73049 13.1499 4.92493C13.1499 5.11938 13.0888 5.27771 12.9666 5.39994L6.83327 11.5333C6.76661 11.5999 6.69438 11.6472 6.61661 11.6749C6.53883 11.7027 6.45549 11.7166 6.36661 11.7166Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};

export default Check;
